import React, { useEffect } from "react";
import * as S from "./styled";
import AboutUsImage from "../../assets/images/aboutus/aboutusImg.webp";
import AboutUsLogo from "../../assets/images/aboutus/aboutusLogo.png";
import SubVisualAboutus from "../../assets/subVisual/subVisualAboutUs.webp";
import SubVisual from "../../components/SubVisual";
import Aos from "aos";
import { Helmet } from "react-helmet-async";

const Aboutus = () => {
  useEffect(() => {
    if (typeof window === "undefined") return;

    const isReactSnap = navigator.userAgent === "ReactSnap";

    if (!isReactSnap) {
      Aos.init();
      window.scrollTo(0, 0);
    } else {
      window.scrollTo(0, document.body.scrollHeight);
    }
  }, []);
  return (
    <>
      <Helmet>
        <title>IPDIA 국제실용댄스지도자협회</title>

        <meta
          name="description"
          content="전문 댄스강사 양성 및 실용무용 교육과 네트워크를 선도하는 국제실용댄스지도자협회입니다."
        />

        <meta
          name="keywords"
          content="IPDIA, 아이피디아, 국제실용댄스지도자협회, 국제실용댄스, 셔플댄스, 댄스협회, 댄스자격증, 실용무용, 댄스강사자격증"
        />

        <meta property="og:title" content="넵튠 댄스 스튜디오" />
        <meta
          property="og:description"
          content="전문 댄스강사 양성 및 실용무용 교육과 네트워크를 선도하는 국제실용댄스지도자협회입니다."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://ipdiakorea.com" />
        <meta
          property="og:image"
          content="https://ipdiakorea.com/og-image.png"
        />
      </Helmet>
      <S.AboutusContainer>
        <SubVisual src={SubVisualAboutus} title="인사말" subTitle="협회 소개" />
        <S.AboutusWrapper>
          <div className="inner">
            <S.AboutusWrap>
              <S.AboutusImgWrap
                data-aos="fade"
                data-aos-duration={600}
                data-aos-easing="linear"
              >
                <img src={AboutUsImage} alt="about us" />
              </S.AboutusImgWrap>
              <S.AboutusTextWrap>
                <img
                  src={AboutUsLogo}
                  alt="about us"
                  data-aos="fade-left"
                  data-aos-duration={600}
                  data-aos-delay={200}
                  data-aos-easing="linear"
                />
                <div
                  className="text-wrap"
                  data-aos="fade-left"
                  data-aos-duration={600}
                  data-aos-delay={400}
                  data-aos-easing="linear"
                >
                  <h6>IPDIA 국제실용댄스지도자협회는</h6>
                  <p>
                    실용무용을 지도할 수 있는 다양한 장르의 전문인을
                    <br />
                    체계적으로 양성하고 배출하는 교육기관입니다.
                    <br />
                    <br />
                    연령, 성별, 국적에 제한되지 않는 전문 강사진 배출을 비전으로
                    하며,
                    <br className="pc-br" />
                    한국 실용댄스 장르의 글로벌한 활동과 교류를 촉진하고
                    있습니다.
                    <br />
                    <br />
                    트레이닝에 탁월한 강사진과 전문화된 커리큘럼으로 <br />
                    다양한 장르의 전문가 양성을 주도하며,
                    <br />
                    공정하고 합리적인 강사 보호 시스템 구축에 앞장서는 조직이
                    되겠습니다.
                  </p>
                </div>
                <div
                  className="bold-text-wrap"
                  data-aos="fade-left"
                  data-aos-duration={600}
                  data-aos-delay={600}
                  data-aos-easing="linear"
                >
                  <h4>
                    국제실용댄스지도자협회장
                    <br />
                    박지원
                  </h4>
                </div>
              </S.AboutusTextWrap>
            </S.AboutusWrap>
          </div>
        </S.AboutusWrapper>
      </S.AboutusContainer>
    </>
  );
};

export default Aboutus;
